// extracted by mini-css-extract-plugin
export default {"container":"q2-z","heading":"r2-z","links":"s2-z","copy":"t2-z","subCopy":"u2-z","linksLeft":"v2-z","linksCenter":"w2-z","linksRight":"x2-z","link":"y2-z","onlyLink":"z2-z"};